const SWOOP_DELAY_MS = 100;

/** Draws the Final CTA swoop once, the first time the card enters the viewport. */
export default function initCtaSwoop(cardId: string): void {
   const card = document.getElementById(cardId);
   const swoop = card?.querySelector(".hp3-cta-swoop");
   if (!card || !swoop) {
      return;
   }

   if (!("IntersectionObserver" in window)) {
      swoop.classList.add("swoop-visible");
      return;
   }

   const observer = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
         observer.disconnect();
         window.setTimeout(() => swoop.classList.add("swoop-visible"), SWOOP_DELAY_MS);
      }
   });
   observer.observe(card);
}
